import * as React from 'react';
import Emittery from 'emittery';
export var formEventBus = new Emittery();
export var formEventBusContextObj = /*#__PURE__*/React.createContext(formEventBus);
export var FormEventBusContextProvider = formEventBusContextObj.Provider;